const isType = (type) => (obj) => obj != null &&
    (Array.isArray(type) ? type : [type]).some((t) => getType(obj) === `[object ${t}]`);
export const getType = (obj) => Object.prototype.toString.call(obj);
export const isPlainObj = isType('Object');
